// ABOUTME: Copy icon showing two overlapping rectangles for profile duplication
// ABOUTME: Drawn in currentColor — `color` when given, else the icon grey (`text-icon`), so it follows the theme

import { cn } from "@shared/lib/utils"

interface CopyIconProps {
  className?: string
  size?: number
  color?: string
}

export const CopyIcon = ({ className = "", size = 16, color }: CopyIconProps) => (
  <svg
    className={cn("text-icon", className)}
    style={color ? { color } : undefined}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect
      x="9"
      y="9"
      width="13"
      height="13"
      rx="2"
      ry="2"
    />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
)
